<template>
  <div>
    <div class="row p-4" v-if="!isCaseResolved">
      <div class="col-12">
        <custom-autocomplete
          ref="autocompleteRef"
          display-text-name="profileFullName"
          :placeholder="$t('PlaceHolderSearchUser.text')"
          :debounce-time="2000"
          :get-result-value="getResultValue"
          :search="searchHandler"
          @submit="handleSubmit"
        />
      </div>
    </div>
    <separator-extended
      :text="$t('UserAssaigment.text')"
      class="case-separator"
    />
    <div class="row px-4 pt-2">
      <div class="col">
        <div
          v-for="(item, index) in items"
          :key="`user-item-${index}`"
          class="border-bottom mb-3 pb-2"
        >
          <div class="d-flex align-items-center">
            <em class="fa fa-user-circle color-secondary-5 font-28" />
            <div class="flex-grow-1 ml-3">
              <div class="lh-1">
                <span class="color-gray-13 font-12">
                  {{ item.date | date }}
                </span>
                <br />
                <span class="color-gray-13 font-12">
                  {{ item.userName }}
                </span>
              </div>
              <div class="color-black font-16 font-weight-bold">
                {{ item.fullName }}
              </div>
            </div>
            <em
              class="far fa-times-circle font-18 cursor-pointer color-red"
              @click="removeHandler(item.profileId)"
              v-if="!isCaseResolved"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CustomAutocomplete, SeparatorExtended } from '@/components/common';
import {
  getAssigmentUsers as _getAssigmentUsers,
  unAssignUserFromItem as _unAssignUserFromItem,
  getProfileUsers as _getProfileUsers,
  assignUserToItem as _assignUserToItem,
} from '@/modules/tickets/api.js';
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  name: 'AssignmentManagement',
  mixins: [alertMixin],
  components: {
    CustomAutocomplete,
    SeparatorExtended,
  },
  data() {
    return {
      businessId: null,
      itemId: null,
      items: [],
      searchInput: null,
    };
  },
  async mounted() {
    this.businessId = this.itemModel.requestNumber;
    this.itemId = this.itemModel.itemId;

    if (this.itemId && this.businessId) {
      await this.callGetAssigmentUsers(this.businessId);
      await this.getBadgeCount(this.businessId);
    }
  },
  methods: {
    async handleSubmit(result) {
      if (result) {
        const payload = [result.userId];

        await _assignUserToItem(this.businessId, payload);

        this.ShowToast(
          'Proceso exitoso',
          'El usuario ha sido asignado exitosamente.',
          'success'
        );

        await this.callGetAssigmentUsers(this.businessId);
        await this.getBadgeCount(this.businessId);
        await this.onResetInputValue();
      }
    },
    getResultValue(result) {
      return result.profileFullName;
    },
    searchHandler(input) {
      return new Promise((resolve) => {
        if (input.length < 3) {
          return resolve([]);
        }

        this.searchInput = input;
        _getProfileUsers(this.businessId).then(({ data: usersResponse }) => {
          const _result = usersResponse.filter((item) =>
            item.profileFullName.toLowerCase().includes(input.toLowerCase())
          );
          resolve(_result);
        });
      });
    },
    async removeHandler(userId) {
      const answer = await this.ShowCancelModal(
        'Remover Asignación',
        '¿Está seguro que desea eliminar la asignación del usuario?',
        'Si',
        'No'
      );

      if (answer) {
        await _unAssignUserFromItem(this.businessId, userId);
        this.ShowToast(
          'Proceso exitoso',
          'La asignación ha sido removida exitosamente.',
          'success'
        );
        await this.getBadgeCount(this.businessId);
        await this.callGetAssigmentUsers(this.businessId);
      }
    },
    async callGetAssigmentUsers(businessId) {
      const { data } = await _getAssigmentUsers(businessId);
      this.items = data;
    },
    async onResetInputValue() {
      this.$refs.autocompleteRef.onClearHandler();
    },
  },
};
</script>

<style>
.lh-1 {
  line-height: 1;
}
</style>
